import React from 'react';
import { Box, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ProviderProductList from './ProviderProductList';

const ProviderProductListPanel = (props) => {
  const { children, value, index, provider } = props;
  const navigate = useNavigate();
  
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
    >
      <Box display="flex" flexDirection="column" gap={1} mt={2}>
        <Typography color="primary" variant="h5">
          <b>Meus produtos</b>
        </Typography>
        <ProviderProductList provider={provider} />
      </Box>
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
};

export default ProviderProductListPanel;